import { ProductPriceDto } from "../product-price/ProductPrice"
import { SupplierCost } from "../product/models"
import { ImageDto } from "./Image"

export type ItemAttributes = {
    title: string
    measure: string
    isIncluded: boolean
    type: string
    id: string
    sku: string
    itemCustomAttributeValues: ItemCustomAttributeValues[]
    itemCustomAttributeDefinitions: ItemCustomAttributeDefinitions[]
    pricingStrategy: string
    images: ImageDto[]
    isNonInventory: boolean
    defaultUnitPrice: number | string
    productPrices: ProductPriceDto[]
    inventoryTracking: boolean
    supplierCosts: Array<SupplierCost>
}

type ItemCustomAttributeDefinitions = {
    id: string
    attributes: ItemCustomAttributeDefinitionAttributes
}

type ItemCustomAttributeDefinitionAttributes = {
    label: string
    isNonInventory: boolean
    images: ImageDto[]
}

type ItemCustomAttributeValues = {
    id: string
    attributes: ItemCustomAttributeValueAttributes
}

type ItemCustomAttributeValueAttributes = {
    value: string
    rowId: string
    customAttributeDefinitionId: string
}


export type ItemDto = {
    id: string
    type: string
    attributes: ItemAttributes
}

export default class Item {
    private dto: ItemDto
    constructor(dto: ItemDto) {
        this.dto = dto
    }

    getTitle(): string {
        return this.dto.attributes.title
    }

    getMeasure() {
        return Number(this.dto.attributes.measure)
    }

    getSKU() {
        return this.dto.attributes.sku
    }

    getPriceFromPriceLevel(selectedPriceLevelId:string){
        const priceLevel=this.dto.attributes.productPrices?.find(p=>p.attributes.priceLevelId==selectedPriceLevelId)
        return priceLevel?.attributes.price
    }

    isPriceLevelEqual(selectedPriceLevelId:string, unitPrice){
        const priceLevelPrice=Number(this.getPriceFromPriceLevel(selectedPriceLevelId))
        return Number(unitPrice) == priceLevelPrice
    }

    isCurrentUnitPriceSameAsDefaultUnitPrice(unitPrice, selectedPriceLevelId) {
        const priceComparison=selectedPriceLevelId? this.isPriceLevelEqual(selectedPriceLevelId,unitPrice):
            (Number(this.dto.attributes.defaultUnitPrice) == Number(unitPrice) ||
            Number(this.dto.attributes.defaultUnitPrice) == 0)

        return (this && this.dto.attributes &&
            this.dto.attributes.defaultUnitPrice && unitPrice && priceComparison)

    }

    getImages() {
        return this.dto.attributes.images
    }

    hasAtLeastOneImage() {
        return this.dto.attributes.images && this.dto.attributes.images.length > 0
    }
}


// WEBPACK FOOTER //
// ./src/state/pricing/Item.ts